


































import { defineComponent, onUnmounted, watch } from '@vue/composition-api';
import { InfoCircleIcon } from 'tdesign-icons-vue';
import internalServerSettingHandler from '@/renderer/components/dialog/setting/internalServerSettingHandler';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
export default defineComponent({
  name: 'InternalServer',
  components: {
    InfoCircleIcon,
  },
  setup(props, context) {
    const {
      internalServerSetting,
      internalServerTestState,
      serverUrlRules,
      methods: internalServerMethods,
    } = internalServerSettingHandler();
    const methods = {
      async submit() {
        const valid = await (context.refs.serverForm as any).validateOnly();
        if (typeof valid !== 'boolean') return;
        await internalServerMethods.testInternalServer();
        if (internalServerTestState.status !== 'success') {
          tips.error(internalServerTestState.msg, false);
          return;
        }
        internalServerMethods.saveInternalServerSetting();
        context.emit('onSuccess');
      },
      updateServerUrl(serverUrl: string) {
        internalServerSetting.url = serverUrl;
      },
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.CHANGE_SERVER_URL, methods.updateServerUrl);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.CHANGE_SERVER_URL, methods.updateServerUrl);
    });
    return {
      internalServerSetting,
      internalServerTestState,
      serverUrlRules,
      ...methods,
    };
  },
});
